import React from 'react'
import { motion } from 'framer-motion'

const LogoMosyapay = () => {

    const icon = {
        hidden: {
          pathLength: 0,
          opacity: 0
        },
        visible: {
          pathLength: 1,
          opacity: 1
        }
    }

  return (
    <svg width="60" height="60" viewBox="0 0 555 510" fill="none" xmlns="http://www.w3.org/2000/svg">
        <motion.path 
            variants={icon} 
            transition={{
                duration: 1.5,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatType: 'reverse',
            }}
            initial="hidden"
            animate="visible" 
            d="M276.89 273.996L71.8649 477.365L69.599 72.9375L276.89 273.996Z" 
            fill="url(#paint0_linear_6_6)"/>
        <motion.path 
            variants={icon} 
            transition={{
                duration: 1.5,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatType: 'reverse',
            }}
            initial="hidden"
            animate="visible" 
            d="M275.058 277.045L475.961 69.6035L71.5353 72.1724L275.058 277.045Z" 
            fill="url(#paint1_linear_6_6)"/>
        <motion.path 
            variants={icon} 
            transition={{
                duration: 1.5,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatType: 'reverse',
            }}
            initial="hidden"
            animate="visible" 
            d="M275.167 274.368L477.686 68.5044L484.903 472.874L275.167 274.368Z" 
            fill="url(#paint2_linear_6_6)"/>
        <defs>
            <linearGradient id="paint0_linear_6_6" x1="215" y1="275" x2="10.8431" y2="91.9637" gradientUnits="userSpaceOnUse">
                <stop/>
                <stop offset="1" stopColor="white" stopOpacity="0"/>
                </linearGradient>
                <linearGradient id="paint1_linear_6_6" x1="275.321" y1="215.148" x2="89.3568" y2="14.5103" gradientUnits="userSpaceOnUse">
                <stop/>
                <stop offset="1" stopColor="white" stopOpacity="0"/>
                </linearGradient>
                <linearGradient id="paint2_linear_6_6" x1="337.039" y1="272.607" x2="572.691" y2="484.605" gradientUnits="userSpaceOnUse">
                <stop/>
                <stop offset="1" stopColor="white" stopOpacity="0"/>
            </linearGradient>
        </defs>
    </svg>
  )
}

export default LogoMosyapay
